/**
 * Where to go after signing in (FR-001f). ProtectedRoute puts the page the person was on —
 * path, query and hash, so the list's page and filters too — in the router state as `from`;
 * the login form and both 2FA pages carry it along and navigate there once a token is issued.
 */

export interface ReturnToState {
  from?: string;
}

/** The pages that sign a person in: never a place to return to. */
const AUTH_PATHS = ['/login', '/2fa/'];

/**
 * The in-app path held in a router state's `from`, or '/' when there is none or it is not a
 * same-origin path (`//host` and `/\host` are protocol-relative to a browser) or is an auth page.
 */
export function returnPathFrom(state: unknown): string {
  const from = (state as ReturnToState | null)?.from;
  if (typeof from !== 'string' || !from.startsWith('/') || from.startsWith('//') || from.startsWith('/\\')) {
    return '/';
  }
  if (AUTH_PATHS.some((path) => from.startsWith(path))) {
    return '/';
  }
  return from;
}
